import { FC, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  Container,
  Header,
  Title,
  StyledTableHead,
  StyledTablePagination,
  StyledTableRow,
} from 'containers/CourtManagerAssignedExpertise/style';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
} from 'containers/UploadDocuments/actions';
import { resolveSagisClaim } from 'helpers/utils';
import { isBlockStatusClaim } from 'containers/CourtManagerLegalProceedings/utils';
import messages from 'containers/CourtManagerAssignedExpertise/messages';
import { translate } from 'containers/services/translate';
import {
  requestFindMissions,
  resetFoundMissionsStore,
} from 'containers/ExpertHomePage/actions';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import { makeSelectedMissions } from 'containers/ExpertHomePage/selectors';
import { connect } from 'react-redux';
import {
  requestExpertiseMissions,
  requestUpdateMission,
  requestGetClaimInfo,
} from 'containers/CourtManagerAssignedExpertise/actions';
import { requestGetCivilProceeding } from 'containers/LawyerLegalProceedingsPage/actions';
import { isRejectedMission } from 'containers/CourtManagerAssignedExpertise/utils';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import * as utils from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { get, isNil } from 'lodash';
import MissionRecapDrawer from 'containers/CourtManagerAssignedExpertise/MissionRecapDrawer';
import SearchBarExpert from 'containers/ExpertHomePage/SearchBarExpert';
import UpdateMissionDrawer from 'containers/CourtManagerAssignedExpertise/DrawerMission';
import ActionDropDown from 'components/ActionDropDown';
import { requestCorporealLawyers } from 'containers/RecapManagerPage/actions';
import {
  makeSelectCorporealExperts,
  makeSelectCorporealLawyers,
} from 'containers/RecapManagerPage/selectors';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';

import {
  requestSearchClaims,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import { requestGetExpertUsers } from 'containers/CourtManagerLegalProceedings/actions';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';

export interface CourtManagerAssignedExpertiseProps {
  intl: IntlShape;
  requestExpertiseMissions: Function;
  location: { pathname: string };
  requestFindMissions: Function;
  resetFoundMissionsStore: Function;
  requestCorporealLawyers: Function;
  requestGetExpertUsers: Function;
  uploadDocument: Function;
  resetUploadDocumentStore: Function;
  setDocumentId: Function;
  requestUpdateMission: Function;
  requestGetClaimInfo: Function;
  requestGetCivilProceeding: Function;
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  requestGetDocByDocumentumId: Function;
}

const CourtManagerAssignedExpertise: FC<CourtManagerAssignedExpertiseProps> = props => {
  const { requestExpertiseMissions } = props;
  useEffect(() => {
    requestExpertiseMissions([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [isSearch, setIsSearch] = useState(false);
  const [selectedMission, setSelectedMission] = useState({} as any);

  const [searchQuery, setSearchQuery] = useState<any>({
    cin: null,
    claimNumber: null,
    reference: null,
  });

  const corporealLawyers = useSelector(makeSelectCorporealLawyers());
  const corporealExperts = useSelector(makeSelectCorporealExperts());
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const listings = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings'], []),
  );
  const foundedMissions = useSelector(makeSelectedMissions());
  const missions = useSelector((state: any) =>
    get(state.toJS(), ['expertiseMissions', 'expertiseMissions'], []),
  );
  const policyInfo = useSelector(makeSelectSearchClaims());
  const expertiseTypeList = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'expertise'], []),
  );
  const proceduresTypeList = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'procedureNature'], []),
  );
  const jurisdictionDegreesTypeList = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'jurisdictionDegrees'], []),
  );
  const jurisdictionList = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'jurisdiction'], []),
  );
  const missionStatus = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'missionStatus'], []),
  );
  const claimInfo = useSelector((state: any) =>
    get(state.toJS(), ['expertiseMissions', 'claimInfo'], []),
  );
  const civilProceeding = useSelector((state: any) =>
    get(state.toJS(), ['lawyerJudgement', 'civilProceeding'], []),
  );
  const resolveMissions = () => {
    if (isSearch) return get(foundedMissions, 'missions', []);
    return missions;
  };
  useEffect(() => {
    props.requestCorporealLawyers();
  }, []);

  useEffect(() => {
    if (isBlockStatusClaim(policyInfo)) {
      setOpenedUpdatedDrawer(false);
      setSelectedMission({});
      toast.success(
        translate(messages.statusToastTitle, props, {
          status: get(resolveSagisClaim(policyInfo), 'status'),
        }),
      );
      props.resetSearchClaimsStore();
    }
  }, [policyInfo]);
  const missionRows: any[] = resolveMissions().map((mission: any) => ({
    missionNumber: mission?.reference,
    assignedExpert: mission?.assignedExperts,
    courtFileNumber: mission?.courtFileNumber,
    type: mission?.type,
    missionDate: isNil(mission?.missionDate)
      ? ''
      : moment(mission?.missionDate).format('DD/MM/YYYY'),
    formattedMissionDate: isNil(mission?.missionDate)
      ? ''
      : moment(mission?.missionDate).format('YYYY-MM-DD'),
    claimNumber: mission?.claim?.claimNumber,
    city: getValueByCode(mission?.city, jurisdictionList),
    cityCode: mission?.city,
    address: mission?.address,
    document: mission?.document,
    lossHour: mission?.hour,
    typeCode: getValueByCode(mission?.type, expertiseTypeList),
    procedureNatureId: mission?.procedureNatureId,
    procedureCode: getValueByCode(
      mission?.procedureNatureId,
      proceduresTypeList,
    ),
    stepId: mission?.step,
    stepCode: getValueByCode(mission?.step, jurisdictionDegreesTypeList),
    legalExpert: mission?.legalExpert,
    lawyer: mission?.lawyer,
    victims: mission?.victims,
    vehicles: mission?.vehicles,
    victim:
      get(mission?.victims, '[0].firstName', ' ') +
      ' ' +
      get(mission?.victims, '[0].lastName', ' '),
    vehicle: get(mission?.vehicles, '[0].registrationNumber', ' '),
    id: mission?.id,
    claimId: mission?.claim?.id,
    judiciaryProcessId: mission?.judiciaryProcessId,
    receiptDate: moment(mission?.receiptDate).format('DD/MM/YYYY'),
  }));

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const uploadedDocument = useSelector(makeSelectDocument());
  const documentId = useSelector(makeSelectDocumentId());
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = () => {
    setIsSearch(true);
    props.requestFindMissions(searchQuery);
  };
  const handleRefresh = () => {
    setIsSearch(false);
    props.resetFoundMissionsStore();
  };

  const tableHeaderTitles = [
    translate(messages.claimNumber, props),
    translate(messages.courtNumber, props),
    translate(messages.missionNumber, props),
    translate(messages.appointedExpert, props),
    translate(messages.type, props),
    translate(messages.missionDate, props),
    translate(messages.concernedParty, props),
    translate(messages.city, props),
    '',
  ];

  const [openedDrawer, setOpenedDrawer] = useState(false);
  const [openedUpdateDrawer, setOpenedUpdatedDrawer] = useState(false);
  /* istanbul ignore next */
  const openDrawer = (mission: any) => {
    setSelectedMission(mission);
    setOpenedDrawer(true);
  };
  /* istanbul ignore next */
  const openUpdateDrawer = (mission: any) => {
    setSelectedMission(mission);
    setOpenedUpdatedDrawer(true);
  };
  const closeDrawer = () => setOpenedDrawer(false);
  return (
    <>
      <Container>
        <Header>
          <Title>{translate(messages.missionTitleTable, props)}</Title>
          <SearchBarExpert
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            handlerSearch={handleSearch}
            handlerRefresh={handleRefresh}
          />
        </Header>
        <TableContainer>
          <Table>
            <StyledTableHead>
              <TableRow>
                {tableHeaderTitles.map(title => (
                  <TableCell key={title}>{title}</TableCell>
                ))}
              </TableRow>
            </StyledTableHead>
            <TableBody>
              {missionRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row: any) => {
                  return (
                    <StyledTableRow
                      data-testid="mission-row"
                      key={`${row.missionNumber}${row.victim}`}
                      onClick={() => openDrawer(row)}
                    >
                      <TableCell>{row.claimNumber}</TableCell>
                      <TableCell>{row.courtFileNumber}</TableCell>
                      <TableCell component="th" scope="row">
                        {row.missionNumber}
                      </TableCell>
                      <TableCell>
                        {row.assignedExpert
                          .map((element: any) =>
                            utils.getValueByCode(
                              element.expertCode,
                              get(listings, 'intervenants'),
                            ),
                          )
                          .join(', ')}
                      </TableCell>
                      <TableCell>
                        {getValueByCode(row.type, expertiseTypeList)}
                      </TableCell>
                      <TableCell>{row.missionDate}</TableCell>
                      <TableCell>
                        {row.victim ? row.victim : row.vehicle}
                      </TableCell>
                      <TableCell>{row.city}</TableCell>
                      <TableCell>
                        <ActionDropDown
                          label={translate(messages.action, props)}
                          items={
                            row.missionDate != '' &&
                            row.formattedMissionDate <=
                              moment(new Date()).format('YYYY-MM-DD') &&
                            !isRejectedMission(row)
                              ? [
                                  {
                                    title: translate(messages.consult, props),
                                    onClick: () => openDrawer(row),
                                  },
                                ]
                              : [
                                  {
                                    title: translate(messages.consult, props),
                                    onClick: () => openDrawer(row),
                                  },
                                  {
                                    title: translate(messages.update, props),
                                    onClick: () => {
                                      props.resetSearchClaimsStore();
                                      props.requestSearchClaims({
                                        claimNumber: get(
                                          row,
                                          'claimNumber',
                                          null,
                                        ),
                                      });
                                      props.requestGetClaimInfo({
                                        claimId: row.claimId,
                                      });
                                      props.requestGetCivilProceeding(
                                        row.claimId,
                                      );
                                      openUpdateDrawer(row);
                                    },
                                  },
                                ]
                          }
                        />
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <StyledTablePagination
          rowsPerPageOptions={[5, 10, 25]}
          count={missionRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={translate(messages.rowsPerPage, props)}
        />
      </Container>
      {openedDrawer && (
        <MissionRecapDrawer
          mission={selectedMission}
          closeDrawer={closeDrawer}
          listings={listings}
          missionStatus={missionStatus}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      {openedUpdateDrawer && (
        <UpdateMissionDrawer
          open={openedUpdateDrawer}
          handleToggleDrawer={() => {
            if (isSearch) {
              handleSearch();
            }
            setOpenedUpdatedDrawer(false);
          }}
          listings={listings}
          victims={get(claimInfo, 'claim.victims', [])}
          uploadDocument={props.uploadDocument}
          mission={selectedMission}
          uploadedDocument={uploadedDocument}
          resetUploadedDocument={props.resetUploadDocumentStore}
          setDocumentId={setDocumentId}
          documentId={documentId}
          requestUpdateMission={props.requestUpdateMission}
          claimId={get(selectedMission, 'claimId') as any}
          claimNumber={get(selectedMission, 'claimNumber') as any}
          judiciaryProcessId={get(selectedMission, 'judiciaryProcessId') as any}
          courtFileNumber={get(selectedMission, 'courtFileNumber') as any}
          requestCorporealLawyers={props.requestCorporealLawyers}
          corporealLawyers={corporealLawyers}
          assignedLawyer={get(selectedMission, 'lawyer')}
          searchQuery={{}}
          civilProceeding={civilProceeding}
          vehicles={get(claimInfo, 'claim.vehicules', [])}
          corporealExperts={corporealExperts}
          requestGetExpertUsers={props.requestGetExpertUsers}
          riskKey={
            get(resolveSagisClaim(policyInfo), 'offeredRisks', []).find(
              /* istanbul ignore next */ (element: { riskName: string }) =>
                element.riskName === rcCoporeal,
            )?.riskId
          }
        />
      )}
    </>
  );
};

const mapDispatchToProps = {
  requestExpertiseMissions,
  requestFindMissions,
  resetFoundMissionsStore,
  requestCorporealLawyers,
  requestGetExpertUsers,
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
  requestUpdateMission,
  requestGetClaimInfo,
  requestGetCivilProceeding,
  requestSearchClaims,
  resetSearchClaimsStore,
  requestGetDocByDocumentumId,
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(CourtManagerAssignedExpertise));
